import { AfterViewInit, Component, ElementRef, Input, NgZone, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-embedded-video',
  templateUrl: './embedded-video.component.html',
  styleUrls: ['./embedded-video.component.css']
})
export class EmbeddedVideoComponent implements AfterViewInit, OnChanges {
  @ViewChild('videoContainer', { static: true }) videoContainer!: ElementRef;
  @Input() videoId = '';
  private iframe!: HTMLIFrameElement;

  constructor(private sanitizer: DomSanitizer, private ngZone: NgZone) { }

  ngAfterViewInit(): void {
    this.fetchVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoId']) {
      this.fetchVideo();
    }
  }

  fetchVideo(): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.iframe) {
        this.videoContainer.nativeElement.removeChild(this.iframe);
        this.iframe = undefined as any; // Clear reference
      }
      this.iframe = document.createElement('iframe');

      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
      if (isMobile) {
        this.iframe.width = '300';
        this.iframe.height = '169';
      } else {
        this.iframe.width = '560';
        this.iframe.height = '315';
      } 

      this.iframe.src = `https://www.youtube.com/embed/${this.videoId}`;
      this.iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      this.iframe.allowFullscreen = false;

      this.videoContainer.nativeElement.appendChild(this.iframe);
    });
  }

  getSafeUrl(videoId: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`);
  }
}
